import $ from 'jquery';

/* global x5script */

class LoadCourses {
  constructor() {
    this.loadCoursesBtn = $('.js-courses-load-more-btn');
    this.isLoading = false;
    this.page = 2;

    this.loadMoreCourses();
  }

  loadMoreCourses() {
    if (!this.loadCoursesBtn.length) {
      return;
    }

    this.loadCoursesBtn.on('click', e => {
      e.preventDefault();

      if (this.isLoading) {
        return;
      }

      const self = $(e.currentTarget);
      this.loadMore = self.parent();
      this.loader = this.loadMore.find('.js-loader');
      this.courses = self.closest('.js-courses');
      this.speciality = this.courses.attr('data-courses-speciality');

      this.loadCourses();
    });
  }

  loadCourses() {
    this.loader.show();

    $('.js-courses-error').remove();

    const data = {
      action: 'load_more_courses',
      speciality: this.speciality,
      page: this.page,
      security: x5script.security,
    };

    $.post(x5script.ajaxurl, data, response => {
      if (response.error) {
        this.courses.append(
          `<div class="c-courses__error js-courses-error o-layout__item">${
            response.error
          }</div>`,
        );
      } else if (response.ok) {
        this.loadMore.before(response.courses);

        if (response.last_page) {
          this.page = 2;
          this.loadMore.hide().remove();
        } else {
          this.page += 1;
        }
      }

      this.loader.hide();
      this.isLoading = false;
    });

    this.isLoading = true;
  }
}

export default new LoadCourses();



// WEBPACK FOOTER //
// ./src/scripts/modules/load-courses.js